var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTheoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#338EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6635 21H18.3364M15.9999 7V8M22.3639 9.63604L21.6568 10.3431M25 15.9999H24M8 15.9999H7M10.3431 10.3431L9.63599 9.63604M12.4644 19.5356C10.5118 17.5829 10.5118 14.4171 12.4644 12.4645C14.417 10.5119 17.5829 10.5119 19.5355 12.4645C21.4881 14.4171 21.4881 17.5829 19.5355 19.5356L18.9884 20.0827C18.3555 20.7155 17.9999 21.5739 17.9999 22.469V23C17.9999 24.1046 17.1045 25 15.9999 25C14.8954 25 13.9999 24.1046 13.9999 23V22.469C13.9999 21.5739 13.6444 20.7155 13.0115 20.0827L12.4644 19.5356Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheoryIcon);
export default __webpack_public_path__ + "static/media/TheoryIcon.e2633a4370f7b7dd650b8f8830ebd799.svg";
export { ForwardRef as ReactComponent };